/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
    length?:number;
}

export interface CardListHeadingStyles {
    cardListHeading?: InjectableCss;
    viewallLink?: InjectableCss;
    cardListContainer?: InjectableCss;
}

export const CardListHeadingStyles: CardListHeadingStyles = {
    cardListHeading: {
        css: css`
            color: #002554;
            font-size: 1.25rem;
            font-weight: 600;
            letter-spacing: 0;
            line-height: 1.375rem;
            margin-bottom: 0;
        `,
    },
    viewallLink: {
        css: css`
            margin-left: 3.125rem;
            margin-top: 0.313rem;
            padding-left: 0.938rem;
            border-left: 1px solid #E4E8F0;
            color: #002554;
            font-size: 0.875rem;
            line-height: 0.938rem;
            letter-spacing: 0;

            span {
                color: #002554 !important;
                font-size: 0.875rem;
                line-height: 0.938rem;
            }

            @media screen and (max-width: 1279px) {
                justify-content: flex-end;
            }
        `,
    },
    cardListContainer: {
        css: css`
            @media screen and (min-width: 990px) {
                margin-left: 0.625rem !important;
            }
            .top-viewall-link{
                cursor: pointer;
                text-decoration: none;

                &.disable-look {
                    cursor: default;
                    pointer-events: none;
                    span {
                        color: #CBCBCB !important;
                    }
                }
            }
            
        `,
    }
};

const styles = CardListHeadingStyles;

const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl,length }) => {
    return (
        <GridItem width={12} {...styles.cardListContainer}>
                <Typography variant="h5" {...styles.cardListHeading}>{heading}</Typography>
                {viewAllUrl && (
                    <Link
                        href={viewAllUrl}
                        typographyProps={{ size: 14 }}
                        {...styles.viewallLink}
                        data-test-selector="cardListHeadingViewAllLink"
                        className={`top-viewall-link ${length ===  0 ? 'disable-look' : ''}`} 
                    >
                        {translate("View all ")}
                    </Link>
                )}
        </GridItem>
    );
};

export default CardListHeading;
